import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericSelect } from '../../components';
import { InputModelWithSource } from '../../models';
import { InputWithSource } from '../../componentTypes';

const CurrencyInput: InputWithSource = ({ input }) => <GenericSelect label={input.name} input={input} />;

CurrencyInput.meta = {
    inputType: InputModelWithSource.name
};

export default observer(CurrencyInput);
